import { TableCellsIcon, DocumentPlusIcon } from '@heroicons/react/24/solid';
import { CameraIcon } from 'src/components/icons/CameraIcon';
import { EditLineIcon } from 'src/components/icons/EditLineIcon';
import { GlobalSettingIcon } from 'src/components/icons/GlobalSettingIcon';
import { SubnetIcon } from 'src/components/icons/SubnetIcon';
import { SwitchIcon } from 'src/components/icons/SwitchIcon';

export const IMPORT_CONFIGURATION_STEPS = [
  {
    id: 1,
    key: 'files',
    label: 'Files',
    icon: <DocumentPlusIcon className="h-6 w-6" />,
  },
  {
    id: 2,
    key: 'vlans-subnets',
    label: 'VLANs and subnet',
    icon: <SubnetIcon className="h-6 w-6" />,
  },
  {
    id: 3,
    key: 'switches',
    label: 'Switches',
    icon: <SwitchIcon className="h-6 w-6" />,
  },
  {
    id: 4,
    key: 'devices',
    label: 'Devices',
    icon: <CameraIcon className="h-6 w-6" />,
  },
  {
    id: 5,
    key: 'connections',
    label: 'Connections',
    icon: <EditLineIcon className="h-6 w-6" />,
  },
  {
    id: 6,
    key: 'global-settings',
    label: 'Global Settings',
    icon: <GlobalSettingIcon className="h-6 w-6" />,
  },
  {
    id: 7,
    key: 'summary',
    label: 'Summary',
    icon: <TableCellsIcon className="h-6 w-6" />,
  },
];
